<template>
  <div class="row q-gutter-sm q-pa-x">
    <div class="col">
      <q-card
        flat
        square
        bordered
        @click="
          dialogAdvanced = true;
          onClickDialog('advanced');
        "
        class="q-ma-xs text-center cursor-pointer"
      >
        <span
          class="text-green-7 text-caption text-bold"
          :style="`font-size: ${$q.screen.gt.xs ? '15px' : '9px'}`"
        >
          {{ liveMarketCounts.advanced }}
          <q-separator inset color="green-7" />
          Advanced
        </span>
        <q-tooltip class="bg-primary"
          >click to see Advanced stock</q-tooltip
        ></q-card
      >
      <q-dialog v-model="dialogAdvanced" square>
        <q-card flat bordered>
          <q-card-section class="bg-primary text-white">
            <q-bar class="bg-primary text-white">
              <div class="text-h6">Advanced Stocks</div>
              <q-space></q-space>
              <q-btn
                class="q-px-xs q-mx-sm"
                v-close-popup
                text-color="white"
                color="red"
                dense
                size="sm"
                icon="close"
              >
                <q-tooltip class="bg-white text-primary">Close</q-tooltip>
              </q-btn>
            </q-bar>
          </q-card-section>
          <q-card-section>
            <q-table
              flat
              bordered
              dense
              :rows="dialogTableData"
              :columns="columnsMarket"
              :pagination="{
                sortBy: 'symbol',
                descending: false,
                rowsPerPage: 10,
              }"
              separator="cell"
            ></q-table>
          </q-card-section>
        </q-card>
      </q-dialog>
    </div>
    <div class="col">
      <q-card
        flat
        square
        bordered
        @click="
          dialogUnchanged = true;
          onClickDialog('unchanged');
        "
        class="q-ma-xs q-mx-xs-none q-px-xs-none text-center cursor-pointer"
      >
        <span
          class="text-blue-7 text-caption text-bold"
          :style="`font-size: ${$q.screen.gt.xs ? '15px' : '9px'}`"
        >
          {{ liveMarketCounts.unchanged }}
          <q-separator inset color="blue-7" />
          Unchanged
        </span>
        <q-tooltip class="bg-primary"
          >click to see Unchanged stock</q-tooltip
        ></q-card
      >
      <q-dialog v-model="dialogUnchanged" square>
        <q-card flat bordered>
          <q-card-section class="bg-primary text-white">
            <q-bar class="bg-primary text-white">
              <div class="text-h6">Unchanged Stocks</div>
              <q-space></q-space>
              <q-btn
                class="q-px-xs q-mx-sm"
                v-close-popup
                text-color="white"
                color="red"
                dense
                size="sm"
                icon="close"
              >
                <q-tooltip class="bg-white text-primary">Close</q-tooltip>
              </q-btn>
            </q-bar>
          </q-card-section>
          <q-card-section>
            <q-table
              flat
              bordered
              dense
              :rows="dialogTableData"
              :columns="columnsMarket"
              :pagination="{
                sortBy: 'symbol',
                descending: false,
                rowsPerPage: 10,
              }"
              separator="cell"
            ></q-table>
          </q-card-section>
        </q-card>
      </q-dialog>
    </div>
    <div class="col">
      <q-card
        flat
        square
        bordered
        @click="
          dialogDeclined = true;
          onClickDialog('declined');
        "
        class="q-ma-xs text-center cursor-pointer"
      >
        <span
          class="text-red-7 text-caption text-bold"
          :style="`font-size: ${$q.screen.gt.xs ? '15px' : '9px'}`"
        >
          {{ liveMarketCounts.declined }}
          <q-separator inset color="red-7" />
          Declined
        </span>
        <q-tooltip class="bg-primary"
          >click to see Declined stock</q-tooltip
        ></q-card
      >
      <q-dialog v-model="dialogDeclined" square>
        <q-card flat bordered>
          <q-card-section class="bg-primary text-white">
            <q-bar class="bg-primary text-white">
              <div class="text-h6">Declined Stocks</div>
              <q-space></q-space>
              <q-btn
                class="q-px-xs q-mx-sm"
                v-close-popup
                text-color="white"
                color="red"
                dense
                size="sm"
                icon="close"
              >
                <q-tooltip class="bg-white text-primary">Close</q-tooltip>
              </q-btn>
            </q-bar>
          </q-card-section>
          <q-card-section>
            <q-table
              flat
              bordered
              dense
              :rows="dialogTableData"
              :columns="columnsMarket"
              :pagination="{
                sortBy: 'symbol',
                descending: false,
                rowsPerPage: 10,
              }"
              separator="cell"
            ></q-table>
          </q-card-section>
        </q-card>
      </q-dialog>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
export default {
  name: "AdvanceDeclinedUnchanged",
  props: {
    liveMarketData: {
      type: Array,
    },
    liveMarketCounts: {
      type: Object,
    },
  },
  setup(props) {
    const liveMarketTableData = ref([]);
    const dialogTableData = ref([]);
    const dialogAdvanced = ref(false);
    const dialogUnchanged = ref(false);
    const dialogDeclined = ref(false);
    const columnsMarket = [
      {
        name: "symbol",
        label: "Symbol",
        field: "symbol",
        sortable: true,
        align: "left",
      },
      {
        name: "ltp",
        label: "LTP",
        field: "close",
        sortable: true,
        align: "right",
      },
      {
        name: "change",
        label: "Pt.Chg",
        field: "point_change",
        sortable: true,
        sort: (a, b, rowA, rowB) => parseInt(a, 10) - parseInt(b, 10),
        format: (val, row) => {
          return parseFloat(val).toFixed(2);
        },
        style: (row) => {
          return parseFloat(row.point_change) > 0
            ? "color:green"
            : parseFloat(row.point_change) < 0
            ? "color:red"
            : "";
        },
        align: "right",
      },
      {
        name: "percentage_change",
        label: "% Chg",
        field: "percentage_change",
        sortable: true,
        sort: (a, b, rowA, rowB) => parseInt(a, 10) - parseInt(b, 10),
        format: (val, row) => {
          return parseFloat(val).toFixed(2);
        },
        style: (row) => {
          return parseFloat(row.percentage_change) > 0
            ? "color:green"
            : parseFloat(row.percentage_change) < 0
            ? "color:red"
            : "";
        },
        align: "right",
      },
      {
        name: "volume",
        label: "Total Traded",
        field: "volume",
        sortable: true,
        align: "right",
      },
    ];

    function onClickDialog(selected) {
      if (selected == "advanced") {
        dialogTableData.value = props.liveMarketData.filter(
          (item) => item.point_change > 0
        );
      }
      if (selected == "unchanged") {
        dialogTableData.value = props.liveMarketData.filter(
          (item) => item.point_change === 0
        );
      }
      if (selected == "declined") {
        dialogTableData.value = props.liveMarketData.filter(
          (item) => item.point_change < 0
        );
      }
    }
    function onClickAdvanced() {
      liveMarketTableData.value = props.liveMarketData.filter(
        (item) => item.point_change > 0
      );
    }
    function onClickUnchanged() {
      liveMarketTableData.value = props.liveMarketData.filter(
        (item) => item.point_change === 0
      );
    }
    function onClickDeclined() {
      liveMarketTableData.value = props.liveMarketData.filter(
        (item) => item.point_change < 0
      );
    }
    return {
      dialogTableData,
      dialogDeclined,
      dialogUnchanged,
      dialogAdvanced,
      columnsMarket,
      onClickDialog,
      onClickAdvanced,
      onClickUnchanged,
      onClickDeclined,
    };
  },
};
</script>
